import { IconSet } from '@postscript/components';
import { useMemo } from 'react';

import { useHasActivePopups } from 'components/popups-legacy/hooks/useHasActivePopups';

import { SHOW_CASHBACK_PAGES } from 'components/admin/utils/feature-flags';
import { ROUTE_BACK_IN_STOCK } from 'components/backInStock/constants';
import { ROUTE_EMBEDDED_FORMS } from 'components/embeddedForms/constants';
import { ROUTE_LANDING_PAGES } from 'components/landingPages/constants';
import { NavMenuItem, SubMenuItem } from 'components/navigation/NavMenu';
import { BLOCK_POPUP_PATHS } from 'components/popups/constants';
import { ROUTE_SAVED_TARGETING_PROFILES } from 'components/targetingProfiles/constants';
import { EntitlementKeys } from 'providers/entitlements/types';
import { LEGACY_POPUPS_PATH } from 'components/popups-legacy/constants/routes';

export const useAcquisitionsMenuItems = () => {
  const hasActiveLegacyPopups = useHasActivePopups();

  return useMemo(
    (): NavMenuItem[] => [
      {
        id: 'acquisition',
        label: 'Acquisition',
        icon: IconSet.UsersPlus,
        isLoading: false,
        ariaLabelledBy: 'nav-list-growth-title',
        subMenu: [
          {
            id: 'acquisition-popups-block-popups',
            label: 'Popups',
            link: BLOCK_POPUP_PATHS.LIST,
            entitlementKey: EntitlementKeys.ACQUISITION_POPUPS_VIEW,
          },
          {
            id: 'acquisition-back-in-stock',
            label: 'Back in Stock',
            link: ROUTE_BACK_IN_STOCK,
            entitlementKey: EntitlementKeys.ACQUISITION_POPUPS_VIEW,
          },
          ...(hasActiveLegacyPopups
            ? ([
                {
                  id: 'acquisition-popups',
                  label: 'Legacy Popups',
                  link: LEGACY_POPUPS_PATH,
                  entitlementKey: EntitlementKeys.ACQUISITION_POPUPS_VIEW,
                },
              ] as SubMenuItem[])
            : []),
          {
            id: 'acquisition-landing-pages',
            label: 'Landing Pages',
            link: ROUTE_LANDING_PAGES,
            entitlementKey: EntitlementKeys.ACQUISITION_LANDING_PAGES_VIEW,
          },
          {
            id: 'acquisition-embedded-forms',
            label: 'Embedded Forms',
            link: ROUTE_EMBEDDED_FORMS,
            entitlementKey: EntitlementKeys.ACQUISITION_EMBEDDED_FORMS_VIEW,
          },
          {
            id: 'acquisition-targeting-profiles',
            label: 'Targeting Profiles',
            link: ROUTE_SAVED_TARGETING_PROFILES,
          },
          {
            id: 'acquisition-keywords',
            label: 'Keywords',
            link: '/keywords',
            entitlementKey: EntitlementKeys.ACQUISITION_KEYWORDS_VIEW,
          },
          {
            id: 'acquisition-checkout',
            label: 'Checkout Collection',
            link: '/checkout',
            entitlementKey: EntitlementKeys.ACQUISITION_CHECKOUT_VIEW,
          },

          {
            id: 'acquisition-cashback-pages',
            label: 'CashBack',
            link: '/cashback',
            labsFeatureFlag: SHOW_CASHBACK_PAGES,
            entitlementKey: EntitlementKeys.FONDUE_SERVICE_VIEW,
          },
        ],
      },
    ],
    [hasActiveLegacyPopups],
  );
};
